setTimeout(function() { priceoff(); }, 200);
function priceoff(){
  var currency = getCookie("currency");
  console.log("priceoffcalled")
  
  if (currency == "USD"){
   //slash_price();
  }
}


/*$('#selectOptionPopup').on('shown.bs.modal', function (e) {
  // do something...
   var currency = getCookie("currency");
  //console.log("currency", currency)
  
  if (currency == "USD"){
   slash_price();
  }
})*/



function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function slash_price(){

  var product_price_ele = document.getElementsByClassName('product-price');
  var product_price_ele_length = product_price_ele.length;
  var spanprice = "";
  var oriPrice = "";

  if (product_price_ele_length > 0){

        //means there is not sale price
        for(var i = 0; i < product_price_ele_length; i++){

          //if the product already have the sale price 
           var numOfChildEle = document.getElementsByClassName('product-price')[i].children.length
           var spanprice = "";
           var oriPrice = "";
           var oriPriceNum = 0;
           var oriPriceAfterDiscount = 0;
           var percentOffy = "";
          var percentOffs = "";
          var percentOfft = "";
          var percentOffm = "";

          if (numOfChildEle < 2){
           var productPriceEle = document.getElementsByClassName('product-price')[i];
           var eligibleOffer = document.getElementsByClassName('product-price')[i].getAttribute('offer_type');

          //console.log("eligibleOffer", eligibleOffer)

          if(eligibleOffer != null){

     
             document.getElementsByClassName('product-price')[i].getElementsByClassName('product-price__price')[0].setAttribute("style", "text-decoration:line-through;color:#c8c8c8");
         
            
           if (eligibleOffer == "yearly_off"){

             spanprice = document.getElementsByClassName('product-price')[i].firstElementChild.innerText;
         
             oriPrice = spanprice.replace(/\D/g, "");
             oriPriceNum = Number(oriPrice)/100
      //console.log("oriPrice", oriPrice)
             discountPercent = Math.round(((oriPriceNum - 14.99) / oriPriceNum) * 100);
              discountPercentStr = discountPercent + '% off'
             //console.log("discountPercent", discountPercent)
             
             oriPriceAfterDiscount = 14.99;
            // console.log("oriPriceAfterDiscount", oriPriceAfterDiscount)

             percentOffy = discountPercentStr

             
           }else if (eligibleOffer == "sclera_off"){

             

             
             spanprice = document.getElementsByClassName('product-price')[i].firstElementChild.innerText;
         
             oriPrice = spanprice.replace(/\D/g, "");
             oriPriceNum = Number(oriPrice)/100
      //console.log("oriPriceNumt", oriPriceNum)
             discountPercent = Math.round(((oriPriceNum - 64.99) / oriPriceNum) * 100);
              discountPercentStr = discountPercent + '% off'
             //console.log("discountPercent", discountPercent)
             
             oriPriceAfterDiscount = 64.99;
            // console.log("oriPriceAfterDiscount", oriPriceAfterDiscount)

              percentOffs = discountPercentStr

           }else if (eligibleOffer == "toric_off"){

             /*
             spanprice = document.getElementsByClassName('product-price')[i].firstElementChild.innerText;
         
            
             oriPriceAfterDiscount = (oriPriceNum - ((oriPriceNum * 10)/100))/100;
             console.log("oriPriceAfterDiscount", oriPriceAfterDiscount)
             */

            spanprice = document.getElementsByClassName('product-price')[i].firstElementChild.innerText;
       
             oriPrice = spanprice.replace(/\D/g, "");
             oriPriceNum = Number(oriPrice)/100
     // console.log("oriPriceNumt", oriPriceNum)
             discountPercent = Math.round(((oriPriceNum - 39.99) / oriPriceNum) * 100);
             discountPercentStr = discountPercent + '% off'
             console.log("discountPercent", discountPercent)
             
             oriPriceAfterDiscount = 39.99;
            // console.log("oriPriceAfterDiscount", oriPriceAfterDiscount)

             percentOfft = discountPercentStr
             
           }else if (eligibleOffer == "monthly_off"){

             
             spanprice = document.getElementsByClassName('product-price')[i].firstElementChild.innerText;
         
             oriPrice = spanprice.replace(/\D/g, "");
             oriPriceNum = Number(oriPrice)/100

            discountPercent = Math.round(((oriPriceNum - 10.99) / oriPriceNum) * 100);

              discountPercentStr = discountPercent + '% off'
            // console.log("discountPercent", discountPercent)
             
             oriPriceAfterDiscount = 10.99;
           //  console.log("oriPriceAfterDiscount", oriPriceAfterDiscount)


             percentOffm = discountPercentStr

           }

            //create the element for price after discount.
       
            var afterDiscountSpan = document.createElement('span');
            afterDiscountSpan.style = "font-size:16px;font-weight:600;color:#f6418a";
            afterDiscountSpan.className = "priceAfterDiscount";
            afterDiscountSpan.innerHTML = "$"+ oriPriceAfterDiscount.toFixed(2) + " USD"

         
            var discountDescSpan = document.createElement('span');
            discountDescSpan.style = "background-color:#ff4687; padding:3px 10px; border-radius:15px;color:#fff; margin-left:5px;"
            discountDescSpan.className = "offerDesc"
            if (eligibleOffer == "yearly_off"){
               discountDescSpan.innerHTML = percentOffy

              product_price_ele[i].insertBefore(afterDiscountSpan, product_price_ele[i].childNodes[0]);
            product_price_ele[i].appendChild(discountDescSpan);
            }else if(eligibleOffer == "sclera_off"){
              discountDescSpan.innerHTML = percentOffs
              product_price_ele[i].insertBefore(afterDiscountSpan, product_price_ele[i].childNodes[0]);
            product_price_ele[i].appendChild(discountDescSpan);
            }else if(eligibleOffer == "toric_off"){
              discountDescSpan.innerHTML = percentOfft
              product_price_ele[i].insertBefore(afterDiscountSpan, product_price_ele[i].childNodes[0]);
              product_price_ele[i].appendChild(discountDescSpan);
            }else if(eligibleOffer == "monthly_off"){
               discountDescSpan.innerHTML = percentOffm
              product_price_ele[i].insertBefore(afterDiscountSpan, product_price_ele[i].childNodes[0]);
            product_price_ele[i].appendChild(discountDescSpan);
            }
            

            

            
          }
          
        }
        
      }
  }
}